{
  "marketing": {
    "footerProduct": "Producto",
    "navForDevelopers": "Para desarrolladores",
    "navForPm": "Para PMs",
    "navHome": "Inicio",
    "navOpenApp": "Abrir app →",
    "navStart": "Empieza gratis →",
    "navPricing": "Precios"
  },
  "homepage": {
    "edition": "VOL. 1 · EDICIÓN 2026",
    "footerBlurb": "Una incubadora de ideas nativa de agentes. Construida sobre un agente Rust autoalojado, Postgres + pgvector y refs en S3. SaaS de código cerrado: exporta tus datos a markdown cuando quieras.",
    "footerSignIn": "INICIAR SESIÓN",
    "footerGitHub": "GITHUB",
    "footerGoogle": "GOOGLE",
    "footerMagicLink": "ENLACE MÁGICO",
    "footerEdition": "VOL. 1 · NÚM. 1 · ACCESO ANTICIPADO GLOBAL · EDICIÓN 2026",
    "footerPrivacy": "PRIVACIDAD",
    "footerTerms": "TÉRMINOS",
    "footerContact": "CONTACTO"
  }
}
